import React from 'react';
import PropTypes from 'prop-types';

import { firestore, getTenantPath } from '../../../../utils/firebase';

class EmployeeName extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
  };

  state = {};

  componentWillMount() {
    firestore.doc(getTenantPath(`/employees/${this.props.id}`))
      .get().then((val) => val.data())
      .then((employee) => {
        this.setState({
          employee,
        });
      });
  }

  render() {
    const { employee } = this.state;
    return (
      <span>{ employee ? employee.name : 'Loading...' }</span>
    );
  }
}

export default EmployeeName;



// WEBPACK FOOTER //
// ./src/components/Common/Lookup/EmployeeName/index.js